/// <reference path="skyward.base.ajaxManager.js"/>
/// <reference path="skyward.base.global.js"/>
/// <reference path="skyward.ui.browse.js"/>
/// <reference path="skyward.ui.buttonManager.js"/>
/// <reference path="skyward.ui.childrecordquickentry.js"/>
/// <reference path="skyward.ui.codeeel.ts"/>
/// <reference path="skyward.ui.controls.js"/>
/// <reference path="skyward.ui.dataobjectviewer.js"/>
/// <reference path="skyward.ui.editablebrowse.js"/>
/// <reference path="skyward.ui.fieldset.js"/>
/// <reference path="skyward.ui.modalLayer.js"/>
/// <reference path="skyward.ui.window.js"/>
(
    function (skyward, $)
    {
        "use strict";

        skyward.ajax = skyward.ajax || {};

        var ajaxManager = skyward.ajaxManager.createAjaxManager(
        {
            requestsStarted: function () { skyward.buttonManager.setClickInProgress(true); },
            requestsCompleted: function () { skyward.buttonManager.setClickInProgress(false); }
        });

        skyward.ajax.getAllInputElements = function (selector)
        {
            return skyward.dataobjectviewer.getFieldValues($(selector));
        };

        skyward.ajax.handleResponse = function (data, prefix, suppressChangeEvent, container)
        {
            handleResponse(data, prefix, suppressChangeEvent, container);
        };

        var handleResponse = function (data, ajaxPrefix, suppressChangeEvent, container)
        {
            if (data === null)
            {
                return;
            }
            const idPrefix = ajaxPrefix ? ajaxPrefix + "_" : "";
            
            if (!container || !container.length)
            {
                var popupId = skyward.window.getCurrentPopupId();

                if (popupId > -1)
                {
                    container = $("#popup" + popupId);
                }
                else
                {
                    container = $(document.body);
                }
            }

            var field;

            var crqeRecords = data.CRQERecords || {};
            for (field in crqeRecords) 
            {
                var crqeRecord = data.CRQERecords[field];
                skyward.childrecordquickentry.SetCRQERecordValues(crqeRecord, container, idPrefix);
            }

            var removeFields = data.Remove || {};
            for (field in removeFields)
            {
                container.find(removeFields[field]).remove(); // kept for backwards compatibility
                container.find(removeFields[field].replace("#", `#${idPrefix}`)).remove();
            }

            var crqeRemoves = data.CRQERemoves || {};
            for (field in crqeRemoves) 
            {
                var clearButton = container.find('#' + idPrefix + data.CRQERemoves[field] + ' > #' + idPrefix + 'ClearButton > a');
                if (clearButton.length == 1)
                {
                    clearButton.trigger('click');
                }
            }

            var updates = data.Update || {};
            for (field in updates)
            {
                if (field.toLowerCase() == "suppresschangeevent")
                {
                    handleResponse({ Update: updates[field] }, ajaxPrefix, true, container);
                    continue;
                }

                if (field.toLowerCase().indexOf("codeeelqueryparameterdata") != -1)
                {
                    var controlID = field.substring(0, field.indexOf('-'));
                    var codeEELInput = $(`[id="${controlID}"],[id="${idPrefix}${controlID}"]`, container);

                    skyward.codeeel.setQueryParameterData(codeEELInput, updates[field]);

                    continue;
                }

                var nameElement = $("[name='" + field + "']", container);

                // if field is an object (rather than string)
                if (updates[field] != null && typeof(updates[field]) == 'object')
                {
                    // It can be items to default a distinct multi select eel with
                    if (nameElement.hasClass("dmsBackingData"))
                    {
                        updateElement(nameElement);
                        continue;
                    }

                    // Or  an array of updates to a browse's fields
                    if (field.toLowerCase() == "browse")
                    {
                        var browseData = {};
                        browseData.currentPage = 1;

                        for (var item in updates[field])
                        {
                            var key = item.charAt(0).toLowerCase() + item.slice(1);
                            browseData[key] = updates[field][item];
                        }

                        skyward.browse.changePage(skyward.browse.getCurrentBrowseName(), browseData);

                        continue;
                    }

                    // Or each element contained in it is a class that can be used to single out the element to update
                    // the element has multiple input elements such as a codeEEL
                    var classes = updates[field];
                    for (var className in classes)
                    {
                        if (className.toLowerCase() == "options")
                        {
                            skyward.controls.setComboBoxOptions(field, updates[field][className], idPrefix);
                        }
                        else
                        {
                            skyward.controls.setValue(nameElement.filter("." + className), updates[field][className], suppressChangeEvent);
                        }
                    }
                }
                // otherwise, update the element whose name is the value of field
                else
                {
                    updateElement(nameElement);
                }
            }

            function updateElement (nameElement)
            {
                if (nameElement.length == 0)
                {
                    //these controls are rendered with the dataObjectViewerId prepended to their name
                    nameElement = $("#" + idPrefix + field, container);
                }

                //The following check takes care of tabs so that after the value is updated the text will be reselected
                var selectionTypes = ["text", "search", "url", "tel", "password"];
                var nameElementIsActive =
                    nameElement[0] &&
                    document.activeElement &&
                    nameElement[0] == document.activeElement &&
                    selectionTypes.indexOf(nameElement[0].type) != -1 &&
                    typeof nameElement[0].selectionStart == "number" &&
                    nameElement[0].selectionStart == 0 &&
                    nameElement[0].selectionEnd > 0 &&
                    nameElement[0].selectionEnd == nameElement[0].value.length;

                skyward.controls.setValue(nameElement, updates[field], suppressChangeEvent);

                // This attached the necessary events so the value can be picked up by the save without giving the input focus
                var elementData = nameElement.data();
                if (nameElement.is("[data-mask]"))
                {
                    skyward.datamask.addMask(nameElement, elementData.mask, null);
                }

                if (nameElementIsActive)
                {
                    nameElement.select();
                }
            }

            var readOnlys = data.ReadOnly || {};
            for (field in readOnlys)
            {
                var control = $("[name='" + field + "']", container);

                if (control.length < 1)
                {
                    control = $("#" + field, container);
                    if (control.length < 1)
                    {
                        control = $("#" + idPrefix + field, container);
                    }
                    if (control.length < 1)
                    {
                        continue;
                    }
                }

                if (readOnlys[field])
                {
                    skyward.controls.disable(control, idPrefix);
                }
                else
                {
                    skyward.controls.enable(control, idPrefix);
                }
            }

            var fieldDatas = data.FieldData || {};
            for (field in fieldDatas)
            {
                var control = $("[name='" + field + "']", container);

                if (control.length < 1)
                {
                    control = $("#" + field, container);
                    if (control.length < 1)
                    {
                        control = $("#" + idPrefix + field, container);
                    }
                    if (control.length < 1)
                    {
                        continue;
                    }
                }

                for (var dataKey in fieldDatas[field])
                {
                    control.data(dataKey, fieldDatas[field][dataKey]);
                }
            }

            var hiddenFields = data.Hidden || {};
            var animateField = data.AnimateHidden || {};
            for (field in hiddenFields)
            {

                if (hiddenFields[field])
                {
                    skyward.controls.hide(field, animateField[field] !== false, idPrefix);
                }
                else
                {
                    skyward.controls.show(field, animateField[field] !== false, idPrefix);
                }
            }

            var message = data.Message;
            if (message)
            {
                skyward.modalLayer.showDialog(message.Title || "", message.Text || "", null, null, message.ClassName || null);
            }

            var appendFields = data.Append || {};
            for (field in appendFields)
            {
                // Object requires a unique id and content and optional class. The ID is used for the wrapper div and the javascript selector
                var appendObject = appendFields[field];
                const foundField = container.find(field).add(container.find(field.replace("#", `#${idPrefix}`)));
                const foundFieldPrefix = foundField.getPrefix();
                var content = appendObject.Content ? $(appendObject.Content) : $();

                // don't add id prefix to elements with data-id-prefix as they require their original id to work property. example: browses
                if (content.data('idPrefix') === undefined)
                {
                    content.find("[id]").addBack("[id]").each(function ()
                    {
                        // we want to exclude children that are being ajaxed in with a parent that has a data id prefix.
                        const thisClosestDataIdPrefix = $(this).closest("[data-id-prefix]");
                        const contentClosestDataIdPrefix = content.closest("[data-id-prefix]");

                        if (thisClosestDataIdPrefix.length != contentClosestDataIdPrefix.length)
                        {
                            return;
                        }

                        if (thisClosestDataIdPrefix.length > 0 && thisClosestDataIdPrefix[0] != contentClosestDataIdPrefix[0])
                        {
                            return;
                        }

                        // don't add the prefix if its already included 
                        if (this.id.startsWith(foundFieldPrefix))
                        {
                            return;
                        }

                        this.id = foundFieldPrefix + this.id;
                    });
                }

                if (appendObject.Content && appendObject.Class)
                {
                    foundField.append($("<div />").html(content).attr("id", foundFieldPrefix + appendObject.Id).addClass(appendObject.Class));
                }
                else if (appendObject.Content)
                {
                    if (appendObject.NoDiv)
                    {
                        foundField.append(content);
                    }
                    else
                    {
                        foundField.append($("<div />").html(content).attr("id", foundFieldPrefix + appendObject.Id));
                    }
                }

                if (appendObject.Id)
                {
                    skyward.window.notifyDOMLoad("#" + idPrefix + appendObject.Id);
                }
            }

            var resetDatePicker = data.ResetDatePicker || {};
            for (field in resetDatePicker)
            {
                var element = $(`#${field},#${idPrefix}${field}`, container);
                if (element.length == 0)
                {
                    element = $("[name='" + field + "']", container);
                }

                element.val("").change();
            }

            if (data.Remove || data.Update)
            {
                skyward.fieldset.alignTitles(container);
            }
        };

        var sendRequest = function (element, selectorOverride, event)
        {
            var $element = element instanceof $ ? element : $(element);

            if ($element.hasClass("ui-disabled") && $element.hasClass("button"))
            {
                return;
            }

            if ($element.hasClass("ajaxDisableMultipleClicks"))
            {
                $element.addClass("ui-disabled");
            }

            var prefix = $element.getPrefix()?.slice(0, -1); // remove trailing underscore from data-id-prefix
            var area = $element.data("ajaxarea");
            var controller = $element.data("ajaxcontroller");
            var action = $element.data("ajaxaction");
            var ajaxContext = $($element.data("ajaxcontext") || selectorOverride);

            if (!ajaxContext.length)
            {
                ajaxContext = skyward.window.getClosestContentPanel($element);

                if (!ajaxContext.length)
                {
                    ajaxContext = $(document.body);
                }
            }

            skyward.ajax.getAllInputElements(ajaxContext).then(data =>
            {
                data._controlAjaxFiredFrom = event.target.name ? event.target.name : event.target.id;

                var browse = skyward.browse.browseList[skyward.browse.getCurrentBrowseName()];
                if (browse && browse.browseName)
                {
                    data[browse.browseName] = skyward.editablebrowse.getEditableData(browse.browseName);
                }

                ajaxManager.ajax(
                    {
                        url: skyward.global.virtualDir + area + "/" + controller + "/" + action,
                        type: "POST",
                        dataType: "JSON",
                        data: data,
                        success: function (data)
                        {
                            handleResponse(data, prefix, false, $(ajaxContext));
                            if ($element.hasClass("ajaxDisableMultipleClicks"))
                            {
                                $element.removeClass("ui-disabled");
                            }
                        }
                    },
                    {
                        requestID: $element.attr("id")
                    });
            });
        };

        skyward.ajax.registerControlForAjax = function (element)
        {
            var $element = element instanceof $ ? element : $(element);

            var selectorOverride = $element.data('ajaxselectoroverride') || "";
            
            $element.on($element.data('ajaxevent'), function (event)
            {
                sendRequest($element, selectorOverride, event);
            });

            if ($element.data('ajaxevent') == "ready")
            {
                $(document).ready(function ()
                {
                    $element.trigger('ready');
                });
            }
        };

        skyward.ajax.unregisterControlAjax = function (element)
        {
            var $element = element instanceof $ ? element : $(element);
            var ajaxEvent = $element.data('ajaxevent');
            if (ajaxEvent)
            {
                $element.off(ajaxEvent);
            }
        };

        var init = function (selector)
        {
            $(selector).find("[data-ajaxaction]").each(function (index, element)
            {
                skyward.ajax.registerControlForAjax(element);
            });
        };

        // Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
